import { combineReducers } from "redux";
import studentsReducer from "./student";
import applicationListReducer from "./applicationList";
import companiesReducer from './companies';
export default combineReducers({
  students: studentsReducer,
  applicationList: applicationListReducer,
  companies: companiesReducer
});
